var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 21,
    viewBox: "0 0 69 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8 0.300003H59.5C58.2 0.300003 57.2 0.700003 56.6 2L48.4 20.7H54.2C54.2 20.7 55.2 18.2 55.4 17.6C56 17.6 61.7 17.6 62.5 17.6C62.7 18.3 63.2 20.6 63.2 20.6H68.4L63.8 0.300003ZM57 13.4C57.5 12.2 59.2 7.7 59.2 7.7C59.2 7.8 59.7 6.5 59.9 5.8L60.3 7.6C60.3 7.6 61.4 12.5 61.6 13.5H57V13.4Z",
    fill: "#3362AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8 14C48.8 18.2 45 21 39.1 21C36.6 21 34.2 20.5 32.9 19.9L33.7 15.3L34.4 15.6C36.2 16.4 37.4 16.7 39.6 16.7C41.2 16.7 42.9 16.1 42.9 14.7C42.9 13.8 42.2 13.2 40 12.2C37.9 11.2 35.1 9.6 35.1 6.7C35.1 2.7 39 0 44.5 0C46.6 0 48.4 0.4 49.5 0.9L48.7 5.3L48.3 4.9C47.3 4.5 46 4.1 44.1 4.1C42 4.2 41 5.1 41 5.9C41 6.8 42.2 7.5 44.1 8.4C47.3 9.9 48.8 11.6 48.8 14Z",
    fill: "#3362AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.499999L0.1 0.0999985H8.7C9.9 0.0999985 10.8 0.499998 11.1 1.8L13 10.8C11.1 6 6.7 2.1 0 0.499999Z",
    fill: "#F9B50B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 0.299997L16.4 20.6H10.5L5.5 3.6C9.1 5.9 12.1 9.5 13.2 12L13.8 14.1L19.2 0.199997H25.1V0.299997Z",
    fill: "#3362AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 0.199997H32.9L29.4 20.6H23.9L27.4 0.199997Z",
    fill: "#3362AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/VisaLogo.5801b56cd0d90fbddbcd281ae2392a62.svg";
export { ForwardRef as ReactComponent };